const Loader = () => {
  return (
    <div className="loader absolute m-auto !top-[50%] inset-x-0 overflow-hidden	!border-l-base">
      Loading...
    </div>
  )
}
export default Loader
